<template>
  <v-form class="form-content" v-model="isValid">
    <v-text-field label="Biển số" v-model="form.plate" :rules="[validate.required]"></v-text-field>
    <v-text-field
      label="Số điện thoại"
      v-model="form.simPhone"
      mask="################"
      :rules="[validate.required, validate.numeric, validate.min]"
    ></v-text-field>
    <v-text-field label="Hãng xe" v-model="form.vehicleBrand"></v-text-field>
    <span>Biểu tượng xe</span>
    <v-radio-group v-model="form.vehicleType" :rules="[validate.required]">
      <v-radio label="Xe máy" :value="1"></v-radio>
      <v-radio label="Xe ôtô" :value="2"></v-radio>
      <v-radio label="Biểu tượng mũi tên" :value="3"></v-radio>
    </v-radio-group>
    <v-btn block round color="success" :loading="isLoading" @click="submit()">Cập nhật</v-btn>
  </v-form>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import validate from '@/utils/validate';

export default {
  name: 'vehicle-edit',
  data () {
    return {
      isValid: false,
      validate: validate,
      form: {
        id: '',
        plate: '',
        simPhone: '',
        vehicleBrand: '',
        vehicleType: 1
      },
      isLoading: false
    };
  },
  computed: {
    ...mapGetters(['selectedVehicle'])
  },
  watch: {
    selectedVehicle () {
      this.bindSelectedVehicle();
    }
  },
  created () {
    if (this.selectedVehicle) {
      this.bindSelectedVehicle();
    }
  },
  methods: {
    ...mapActions(['updateVehicle', 'getVehicles']),
    ...mapMutations(['UPDATE_VEHICLE']),
    bindSelectedVehicle () {
      this.form.id = this.selectedVehicle.id;
      this.form.plate = this.selectedVehicle.plate;
      this.form.simPhone = this.selectedVehicle.simPhone;
      this.form.vehicleBrand = this.selectedVehicle.vehicleBrand;
      this.form.vehicleType = this.selectedVehicle.vehicleType;
    },
    submit () {
      if (this.isValid) {
        this.isLoading = true;
        this.updateVehicle(this.form)
          .then(_ => {
            this.isLoading = false;
            this.UPDATE_VEHICLE(this.form);
            this.$emit('show', false);
            window.getApp.showMessage('Cập nhật thành công');
          })
          .catch(_ => {
            this.isLoading = false;
            window.getApp.showMessage(
              'Cập nhật thất bại, vui lòng thử lại',
              'error'
            );
          });
      }
    }
  }
};
</script>
<style scoped>
.switch {
  margin-top: 10px;
}
.form-content {
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/vehicle/components/edit.vue